import flowchartImg from '../../assets/images/section/flowChart.png'
import Classes from "./DaoFlowChart.module.scss"
const DaoFlowChart=()=>{
    return (
        <img className={Classes.daoImg}src={flowchartImg}/>
    )
}

export default DaoFlowChart